.wrapper {
  padding: 0.5rem;
  background-color: #f2efef !important;
  border-radius: 0.5rem;
}
.input {
  border: none !important;
  background: transparent !important;
  width: 100%;
}
.container {
  flex: 1;
  height: 100%;
  flex-direction: column;
  display: flex;
}
